// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('Please enter your email address'); return; }
    setLoading(true);
    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + '/reset-password',
      });
      if (resetError) throw resetError;
      setSent(true);
    } catch (err) {
      setError(err.message || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card" style={{ maxWidth: 400, width: '100%' }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔐</div>
          <div style={{ fontSize: 22, fontWeight: 800, color: 'var(--primary-dark)' }}>Forgot Password?</div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 8 }}>
            No worries — enter your email and we'll send you a reset link.
          </div>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✉️</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--primary-dark)', marginBottom: 8 }}>Check Your Email</div>
            <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>
              We sent a password reset link to <strong>{email}</strong>. Click the link in the email to reset your password.
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 20, padding: '12px', background: 'rgba(0,0,0,0.03)', borderRadius: 8 }}>
              Didn't get it? Check your spam folder or wait a minute and try again.
            </div>
            <button
              onClick={() => { setSent(false); setEmail(''); }}
              className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', marginBottom: 12 }}
            >
              Try Another Email
            </button>
            <div
              onClick={() => navigate('/login')}
              style={{ textAlign: 'center', fontSize: 13, color: 'var(--primary-light)', cursor: 'pointer', fontWeight: 600, marginTop: 8 }}
            >
              ← Back to Sign In
            </div>
          </div>
        ) : (
          <>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email Address</label>
                <input
                  className="input"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  autoFocus
                />
              </div>
              {error && <div style={{ color: 'var(--error)', fontSize: 13, marginBottom: 12, textAlign: 'center' }}>{error}</div>}
              <button
                className="btn btn-primary btn-lg"
                type="submit"
                disabled={loading}
                style={{ width: '100%', justifyContent: 'center' }}
              >
                {loading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
            <div
              onClick={() => navigate('/login')}
              style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--primary-light)', cursor: 'pointer', fontWeight: 600 }}
            >
              ← Back to Sign In
            </div>
          </>
        )}
      </div>
    </div>
  );
}
